import { Injectable } from "@angular/core";
import { AsyncSubject, Observable, Subject } from "rxjs";
import { Sidebar } from "../models/sidebar.model";

@Injectable({
    providedIn: 'root'
})
export class SidebarService{
    private sidebar: Sidebar;
    private sidebar$: Subject<Sidebar> = new Subject();
    private asyncSidebar$: AsyncSubject<Sidebar> = new AsyncSubject();
    constructor(){}

    public setSidebar(sidebar:Sidebar): void{
        this.sidebar = sidebar;
        this.sidebar$.next(this.sidebar);
    }
    public getSidebar$(): Observable<Sidebar>{
        return this.sidebar$.asObservable();
    }
    public getAsyncSidebar$(): Observable<Sidebar>{
        return this.asyncSidebar$.asObservable();
    }
    public setAsyncSidebar(sidebar:Sidebar): void{
        this.sidebar = sidebar;
        this.asyncSidebar$.next(this.sidebar);
        this.asyncSidebar$.complete();
      }
}